module.exports = __webpack_public_path__ + "static/media/modal_sign_success_title.0d5a629c.png";